<template>
  <v-card flat>
    <v-card-text>
      <v-form>
        <v-row no-gutters>
          <v-col v-for="(segment, sIdx) in urlFieldSegments" :key="sIdx" :cols="colWidth" class="mr-4">
            <v-text-field v-for="urlField in segment" v-bind:key="urlField" v-model="modelUrls[urlField]"
              :label="urlField | titleize" type="url" />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import { splitAt } from 'ramda'
const URL_COLUMN_COUNT = 2

export default {
  name: 'rooftop-urls',
  props: {
    value: {
      type: Object,
      required: false
    }
  },
  computed: {
    modelUrls() {
      return this.value.urls
    },
    urlFieldSegments() {
      return splitAt(Math.ceil(this.urlFields.length / URL_COLUMN_COUNT), this.urlFields)
    },
    colWidth() {
      return 10 / URL_COLUMN_COUNT
    }
  },
  data: function () {
    return {
      urlFields: [
        'logo_url',
        'logo_all_black_url',
        'logo_all_white_url',
        'logo_black_url',
        'logo_white_url',
        'oem_logo_url',
        'oem_logo_black_url',
        'oem_logo_white_url',
        'main_website_url',
        'new_inventory_url',
        'used_inventory_url',
        'service_url',
        'service_scheduling_url',
        'lease_specials_url',
        'finance_specials_url',
        'finance_url',
        'about_us_url',
        'privacy_policy_url',
        'luther_direct_service_url',
        'luther_direct_sales_url',
        'luther_direct_logo_url',
        'facebook_url',
        'facebook_messenger_url',
        'twitter_url',
        'youtube_url',
        'google_maps_url',
        'instagram_url',
        'linkedin_url',
        'pinterest_url'
      ]
    }
  }
}
</script>
